// extracted by mini-css-extract-plugin
export default {"form":"NovoDistribuidor_form__c5ar+","areaBtn":"NovoDistribuidor_areaBtn__xxIxm","btn":"NovoDistribuidor_btn__XOzvF"};